import './src/styles/global.css';

export const onInitialClientRender = () => {
  window.setTimeout(() => {
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-CPJS5H4G5C';
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];

    function gtag() {
      window.dataLayer.push(arguments);
    }

    window.gtag = gtag;

    gtag('js', new Date());

    gtag('config', 'G-CPJS5H4G5C');

    gtag('config', 'AW-17336179046');

    gtag('config', 'AW-17336179046/eFHpCP_EsvYbEOayxMpA', {
      phone_conversion_number: '+1 604 231 9510',
    });
  }, 5000);
};
